export default __webpack_public_path__ + "static/media/HTML.a76c3cf5.png";